import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getLocationChangedListeners } from '@icp/settings';
import { Modal } from 'antd';
import useGlobalJS from '../useGlobalJS';

export default function Effects({ appChildren, onLocationChanged, appConfig }) {
  const ref = useRef({});
  ref.current.onLocationChanged = onLocationChanged;

  const location = useLocation();
  // 全局 modal，给 appConfig.globaJS 里使用
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    ref.current.onLocationChanged?.(location);
    getLocationChangedListeners().forEach((fn) => fn(location));
  }, [location]);

  useGlobalJS(appConfig.globalJS, { modal });

  return (
    <>
      <Outlet />
      {appChildren}
      {contextHolder}
    </>
  );
}

export const EffectsPropTypes = {
  onLocationChanged: PropTypes.func,
  appChildren: PropTypes.node,
  appConfig: PropTypes.shape({
    globalJS: PropTypes.string,
  }),
};

Effects.propTypes = EffectsPropTypes;
